<template>
  <template>
    <Teleport to="#modal"> </Teleport>
  </template>
  <NotificationMessage :scope="$options.name"></NotificationMessage>
  <PageHeader :showActions="currentStep !== 3" title="Template Builder">
    <template #page-header-actions>
      <template v-if="nameEditIsActive">
        <div class="tw-flex tw-gap-2 tw-items-center">
          <input
            v-model="newCampaignTemplateName"
            type="text"
            id="campaignName"
            placeholder="Template name"
            class="tw-block tw-min-w-72 tw-w-full tw-rounded-md tw-border-0 tw-px-2.5 tw-py-1.5 tw-text-gray-900 tw-ring-1 tw-ring-inset tw-ring-gray-300 placeholder:tw-text-slate-900 focus:tw-ring-2 focus:tw-ring-inset focus:tw-ring-blue-600 tw-text-sm tw-leading-6"
          />
          <div class="tw-flex tw-gap-2 tw-items-center">
            <TheButton
              size="small"
              variant="success"
              :disabled="campaignIsSaving"
              @click="updateCampaign()"
            >
              <template #text>Save</template>
            </TheButton>
            <TheButton
              size="small"
              variant="tertiary"
              :disabled="campaignIsSaving"
              @click="cancelEditingCampaignName()"
            >
              <template #text>Cancel</template>
            </TheButton>
          </div>
        </div>
      </template>
      <template v-if="!nameEditIsActive">
        <div class="tw-flex tw-items-center tw-gap-2 tw-flex-wrap">
          <h2 class="tw-text-lg tw-text-blue-900 tw-m-0">
            {{ campaignName }}
          </h2>
          <TheButton
            size="small"
            variant="tertiary"
            :disabled="campaignIsSaving"
            @click="editCampaignName()"
            :hasLeadingIcon="true"
          >
            <template #leading-icon><b-icon-pencil></b-icon-pencil></template>
            <template #text>Edit name</template>
          </TheButton>
        </div>
      </template>
    </template>
  </PageHeader>

  <template v-if="!campaignIsSaving && !campaignsAreLoading">
    <nav aria-label="Progress">
      <ol
        role="list"
        class="tw-list-none tw-divide-solid tw-divide-x-0 tw-divide-y rig tw-divide-gray-300 tw-border-solid tw-bg-white tw-border tw-border-x-0 tw-border-gray-300 md:tw-flex md:tw-divide-y-0 tw-p-0 tw-m-0 twbg"
      >
        <li
          v-for="(step, stepIdx) in steps"
          :key="step.name"
          class="tw-relative md:tw-flex md:tw-flex-1"
        >
          <!-- step IS complete && NOT current && NOT step 5 -->
          <a
            v-if="step.id !== this.currentStep && step.status && step.id !== 3"
            @click.prevent="handleStepChange(step.id)"
            class="tw-group tw-flex tw-w-full tw-items-center tw-cursor-pointer"
          >
            <span
              class="tw-flex tw-items-center tw-px-6 tw-py-4 tw-text-sm tw-font-medium"
            >
              <span
                class="tw-flex tw-w-8 tw-h-8 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-green-50"
              >
                <span class="tw-text-green-600 tw-text-xl"
                  ><b-icon-check></b-icon-check
                ></span>
              </span>
              <span
                class="tw-ml-4 tw-text-sm tw-font-medium tw-text-gray-900"
                >{{ step.name }}</span
              >
            </span>
          </a>
          <!-- step IS complete && IS current && NOT step 5 -->
          <a
            v-else-if="
              step.id === this.currentStep && step.status && step.id !== 3
            "
            @click.prevent="handleStepChange(step.id)"
            class="tw-group tw-flex tw-w-full tw-items-center tw-cursor-pointer"
          >
            <span
              class="tw-flex tw-items-center tw-px-6 tw-py-4 tw-text-sm tw-font-medium"
            >
              <span
                class="tw-flex tw-w-8 tw-h-8 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-green-100 tw-border-3 tw-border-solid tw-border-green-600"
              >
                <span class="tw-text-green-600 tw-text-xl"
                  ><b-icon-check></b-icon-check
                ></span>
              </span>
              <span class="tw-ml-4 tw-text-sm tw-font-bold tw-text-green-600">{{
                step.name
              }}</span>
            </span>
          </a>
          <!-- step IS NOT complete && NOT current && NOT step 5 -->
          <a
            v-else-if="
              step.id !== this.currentStep && !step.status && step.id !== 3
            "
            @click="handleStepChange(step.id)"
            class="tw-group tw-flex tw-w-full tw-items-center tw-cursor-pointer"
          >
            <span
              class="tw-flex tw-items-center tw-px-6 tw-py-4 tw-text-sm tw-font-medium"
            >
              <span
                class="tw-flex tw-w-8 tw-h-8 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-red-50"
              >
                <span class="tw-text-red-600 tw-text-xl"
                  ><b-icon-exclamation></b-icon-exclamation
                ></span>
              </span>
              <span
                class="tw-ml-4 tw-text-sm tw-font-medium tw-text-gray-900"
                >{{ step.name }}</span
              >
            </span>
          </a>
          <!-- step IS NOT complete && IS current && NOT step 5 -->
          <a
            v-else-if="
              step.id === this.currentStep && !step.status && step.id !== 3
            "
            @click="handleStepChange(step.id)"
            class="tw-group tw-flex tw-w-full tw-items-center tw-cursor-pointer"
          >
            <span
              class="tw-flex tw-items-center tw-px-6 tw-py-4 tw-text-sm tw-font-medium"
            >
              <span
                class="tw-flex tw-w-8 tw-h-8 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-border-solid tw-bg-red-100 tw-border-3 tw-red-solid tw-border-red-600"
              >
                <span class="tw-text-red-600 tw-text-xl"
                  ><b-icon-exclamation></b-icon-exclamation
                ></span>
              </span>
              <span class="tw-ml-4 tw-text-sm tw-font-bold tw-text-red-600">{{
                step.name
              }}</span>
            </span>
          </a>

          <!-- IS NOT current && IS step 5 -->
          <button
            v-if="step.id !== this.currentStep && step.id === 3"
            :disabled="!allStepsComplete || !campaignIsComplete"
            @click="handleStepChange(step.id)"
            class="tw-border-0 tw-bg-transparent tw-group tw-flex tw-items-center disabled:tw-cursor-not-allowed tw-cursor-pointer"
          >
            <span
              class="tw-flex tw-items-center tw-px-6 tw-py-4 tw-text-sm tw-font-medium"
            >
              <span
                class="tw-flex tw-h-8 tw-w-8 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-border-2 group-hover:tw-border-gray-900"
                :class="{
                  'tw-text-red-500 tw-bg-gray-100 ':
                    !allStepsComplete || !campaignIsComplete,
                  'tw-text-gray-500 group-hover:tw-text-gray-900 tw-bg-blue-100':
                    allStepsComplete,
                }"
              >
                <span
                  :class="{
                    'tw-text-red-500 tw-font-medium':
                      !allStepsComplete || !campaignIsComplete,
                    'tw-text-gray-900 tw-font-bold': allStepsComplete,
                  }"
                  >{{ step.id }}</span
                >
              </span>
              <span
                class="tw-ml-4 tw-text-sm tw-text-start"
                :class="{
                  'tw-text-red-500 tw-font-medium':
                    !allStepsComplete || !campaignIsComplete,
                  'tw-text-gray-900 tw-font-bold': allStepsComplete,
                }"
              >
                {{
                  allStepsComplete && campaignIsComplete
                    ? step.name
                    : "Complete all steps to review"
                }}
              </span>
            </span>
          </button>
          <!-- IS current && IS step 5 -->
          <a
            v-if="step.id === this.currentStep && step.id === 3"
            class="tw-border-0 tw-bg-transparent tw-group tw-flex tw-items-center"
          >
            <span
              class="tw-flex tw-items-center tw-px-6 tw-py-4 tw-text-sm tw-font-medium"
            >
              <span
                class="tw-flex tw-h-8 tw-w-8 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-border-2 group-hover:tw-border-gray-900"
                :class="{
                  'tw-text-red-500 tw-bg-gray-100 ': !allStepsComplete,
                  'tw-text-gray-500 group-hover:tw-text-gray-900 tw-bg-blue-100':
                    allStepsComplete,
                }"
              >
                <span
                  :class="{
                    'tw-text-red-500 tw-font-medium': !allStepsComplete,
                    'tw-text-gray-900 tw-font-bold': allStepsComplete,
                  }"
                  >{{ step.id }}</span
                >
              </span>
              <span
                class="tw-ml-4 tw-text-sm tw-text-start"
                :class="{
                  'tw-text-red-500 tw-font-medium': !allStepsComplete,
                  'tw-text-gray-900 tw-font-bold': allStepsComplete,
                }"
              >
                {{
                  allStepsComplete ? step.name : "Complete all steps to review"
                }}
              </span>
            </span>
          </a>

          <template v-if="stepIdx !== steps.length - 1">
            <div
              class="tw-absolute tw-right-0 tw-top-0 tw-hidden tw-h-full tw-w-5 md:tw-block"
              aria-hidden="true"
            >
              <svg
                class="tw-h-full tw-w-full tw-text-gray-300"
                viewBox="0 0 22 80"
                fill="none"
                preserveAspectRatio="none"
              >
                <path
                  d="M0 -2L20 40L0 82"
                  vector-effect="non-scaling-stroke"
                  stroke="currentcolor"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </template>
        </li>
      </ol>
    </nav>
  </template>
  <template v-if="campaignsAreLoading || campaignIsSaving">
    <ThePage customWidthClass="tw-w-full tw-max-w-5xl tw-mx-auto">
      <div
        class="tw-flex tw-justify-center tw-items-center tw-w-full tw-h-full tw-max-h-2xl tw-max-w-2xl tw-m-auto"
      >
        <PageSection :fullWidth="true">
          <PulseAnimation>
            <ListSkeleton :numberOfRows="5"></ListSkeleton>
          </PulseAnimation>
        </PageSection>
      </div>
    </ThePage>
  </template>

  <template
    v-if="currentStep === 1 && !campaignsAreLoading && !campaignIsSaving"
  >
    <ThePage class="tw-max-w-lg tw-mx-auto">
      <TheCard>
        <CardHeader
          :showTitle="true"
          title="Set your gift card amount"
        ></CardHeader>
        <!-- <div class="tw-bg-black"> -->
        <CardBody>
          <TheBox>
            <div
              class="tw-p-5 tw-flex tw-flex-col tw-gap-10 tw-items-center tw-justify-center"
            >
              <div
                class="tw-flex tw-flex-col tw-gap-5 tw-items-center tw-justify-center"
              >
                <h2
                  class="tw-text-5xl tw-font-bold tw-leading-6"
                  :class="{
                    'tw-text-red-500': this.giftCardAmount == 0,
                    'tw-text-blue-500': this.giftCardAmount != 0,
                  }"
                >
                  ${{ giftCardAmount }}
                </h2>
                <span class="tw-isolate tw-inline-flex tw-rounded-md">
                  <button
                    type="button"
                    @click="setGiftCardAmount(10)"
                    class="tw-border-none disabled:tw-bg-slate-300 tw-relative tw-inline-flex tw-items-center tw-rounded-l-md tw-bg-white tw-px-3 tw-py-2 tw-text-lg tw-font-semibold tw-text-gray-900 tw-ring-1 tw-ring-inset tw-ring-gray-300 hover:tw-bg-gray-50 focus:tw-z-10"
                  >
                    $10
                  </button>
                  <button
                    type="button"
                    @click="setGiftCardAmount(15)"
                    class="tw-border-none disabled:tw-bg-slate-300 tw-relative tw--ml-px tw-inline-flex tw-items-center tw-bg-white tw-px-3 tw-py-2 tw-text-lg tw-font-semibold tw-text-gray-900 tw-ring-1 tw-ring-inset tw-ring-gray-300 hover:tw-bg-gray-50 focus:tw-z-10"
                  >
                    $15
                  </button>
                  <button
                    type="button"
                    @click="setGiftCardAmount(25)"
                    class="tw-border-none disabled:tw-bg-slate-300 tw-relative tw--ml-px tw-inline-flex tw-items-center tw-bg-white tw-px-3 tw-py-2 tw-text-lg tw-font-semibold tw-text-gray-900 tw-ring-1 tw-ring-inset tw-ring-gray-300 hover:tw-bg-gray-50 focus:tw-z-10"
                  >
                    $25
                  </button>
                  <button
                    type="button"
                    @click="setGiftCardAmount(50)"
                    class="tw-border-none tw-relative tw--ml-px tw-inline-flex tw-items-center tw-rounded-r-md tw-bg-white tw-px-3 tw-py-2 tw-text-lg tw-font-semibold tw-text-gray-900 tw-ring-1 tw-ring-inset tw-ring-gray-300 hover:tw-bg-gray-50 focus:tw-z-10"
                  >
                    $50
                  </button>
                </span>
              </div>
              <template v-if="campaign?.metadata">
                <div>
                  <div class="tw-text-start">
                    <p
                      class="tw-text-lg tw-font-bold tw-leading-6 tw-text-gray-900 tw-text-center tw-m-0"
                    >
                      Or add a custom gift card amount
                    </p>
                    <p
                      class="tw-text-sm tw-font-bold tw-leading-6 tw-text-gray-500 tw-m-0"
                    >
                      Amount must be a whole number of $5 or more
                    </p>
                  </div>

                  <div class="tw-relative tw-rounded-md tw-shadow-sm tw-w-auto">
                    <div
                      class="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-items-center tw-pl-3"
                    >
                      <b-icon-currency-dollar
                        class="tw-h-5 tw-w-5 tw-text-gray-400"
                        aria-hidden="true"
                      ></b-icon-currency-dollar>
                    </div>
                    <input
                      v-model="campaign.metadata.gift_card_amount"
                      @input="validateCustomGiftCardValue"
                      type="text"
                      name="campaignSearch"
                      id="giftCardAmount"
                      class="tw-block tw-w-full tw-rounded-md tw-border-0 tw-px-2.5 tw-py-2 tw-pl-10 tw-text-gray-900 tw-ring-1 tw-ring-inset tw-ring-gray-300 placeholder:tw-text-slate-900 focus:tw-ring-2 focus:tw-ring-inset focus:tw-ring-blue-600 tw-text-lg tw-leading-6"
                      placeholder="Add gift card amount"
                    />
                  </div>
                </div>
              </template>
            </div>
          </TheBox>
        </CardBody>
        <!-- </div> -->
      </TheCard>
    </ThePage>
  </template>
  <template
    v-if="currentStep === 2 && !campaignsAreLoading && !campaignIsSaving"
  >
    <GiftCardsGridV2
      @updateCampaignCustomSelection="updateCampaignCustomSelection"
      :campaign="campaign"
      :custom_selection_ids="customSelection"
      :isCampaignBuilder="true"
    >
    </GiftCardsGridV2>
  </template>
  <template
    v-if="currentStep === 3 && !campaignsAreLoading && !campaignIsSaving"
  >
    <ThePage customWidthClass="tw-max-w-5xl tw-mx-auto">
      <!-- no CC banner -->
      <PageSection title="Campaign template details" class="tw-w-full">
        <div class="tw-flex gap-2 tw-w-full tw-flex-col">
          <template v-if="this.isBoldXchangeAdmin">
            <TheCard>
              <TheBox :withPadding="true">
                <div>
                  <p class="tw-text-lg tw-leading-8 tw-text-gray-700">
                    Do you want add this template to the Bold Xchange templates
                    collection?
                  </p>
                  <BlockStack :gap="300">
                    <div
                      class="tw-flex tw-items-center tw-gap-4 tw-p-4 tw-bg-green-50"
                      :class="{
                        ' tw-bg-green-50':
                          campaign.metadata.campaign_template.isPrivate,
                        'tw-border-solid tw-border-green-600 tw-border-l-4 tw-border-r-0 tw-border-y-0 tw-bg-green-200':
                          !campaign.metadata.campaign_template.isPrivate,
                      }"
                    >
                      <input
                        type="radio"
                        class="tw-h-5 tw-w-5"
                        id="isPrivateFalse"
                        name="isPrivateStatus"
                        :value="false"
                        v-model="campaign.metadata.campaign_template.isPrivate"
                      />
                      <label
                        for="isPrivateFalse"
                        class="tw-text-sm tw-font-bold tw-gray-900 tw-cursor-pointer"
                      >
                        Yes, add this template to the Bold Xchange templates
                        collection and allow all users to view and clone this
                        template.
                      </label>
                    </div>
                    <div
                      class="tw-flex tw-items-center tw-gap-4 tw-p-4"
                      :class="{
                        ' tw-bg-red-50':
                          !campaign.metadata.campaign_template.isPrivate,
                        'tw-border-solid tw-border-red-600 tw-border-l-4 tw-border-r-0 tw-border-y-0 tw-bg-red-200':
                          campaign.metadata.campaign_template.isPrivate,
                      }"
                    >
                      <input
                        type="radio"
                        class="tw-h-5 tw-w-5"
                        id="isPrivateTrue"
                        name="isPrivateStatus"
                        :value="true"
                        v-model="campaign.metadata.campaign_template.isPrivate"
                      />
                      <label
                        for="isPrivateTrue"
                        class="tw-text-sm tw-font-bold tw-gray-900 tw-cursor-pointer"
                      >
                        No, DO NOT add this template to the Bold Xchange
                        templates collection.
                      </label>
                    </div>
                  </BlockStack>
                </div>
              </TheBox>
            </TheCard>
          </template>
          <TheCard :fullWidth="true" class="tw-text-xs tw-overflow-visible">
            <!-- <CardBody class="tw-text-lg tw-overflow-auto"> -->
            <TheBox :withPadding="true">
              <BlockStack :gap="800">
                <template v-if="this?.campaign?.metadata">
                  <BlockStack :gap="300">
                    <BlockStack :gap="400">
                      <template v-if="this?.campaign?.metadata">
                        <div class="sm:tw-flex tw-items-center">
                          <h4
                            class="tw-font-medium tw-text-gray-900 sm:tw-w-64 sm:tw-flex-none sm:tw-pr-6 tw-m-0"
                          >
                            Template name
                          </h4>
                          <template v-if="nameEditIsActive">
                            <div class="tw-flex tw-gap-2 tw-items-center">
                              <input
                                v-model="newCampaignTemplateName"
                                type="text"
                                id="campaignName"
                                placeholder="Template name"
                                class="tw-block tw-min-w-72 tw-w-full tw-rounded-md tw-border-0 tw-px-2.5 tw-py-1.5 tw-text-gray-900 tw-ring-1 tw-ring-inset tw-ring-gray-300 placeholder:tw-text-slate-900 focus:tw-ring-2 focus:tw-ring-inset focus:tw-ring-blue-600 tw-text-sm tw-leading-6"
                              />
                              <div class="tw-flex tw-gap-2 tw-items-center">
                                <TheButton
                                  size="small"
                                  variant="success"
                                  :disabled="campaignIsSaving"
                                  @click="updateCampaign()"
                                >
                                  <template #text>Save</template>
                                </TheButton>
                                <TheButton
                                  size="small"
                                  variant="tertiary"
                                  :disabled="campaignIsSaving"
                                  @click="cancelEditingCampaignName()"
                                >
                                  <template #text>Cancel</template>
                                </TheButton>
                              </div>
                            </div>
                          </template>
                          <template v-if="!nameEditIsActive">
                            <div
                              class="tw-flex tw-items-center tw-gap-2 tw-flex-wrap"
                            >
                              <h2 class="tw-text-lg tw-text-blue-900 tw-m-0">
                                {{ campaignName }}
                              </h2>
                              <TheButton
                                size="small"
                                variant="tertiary"
                                :disabled="campaignIsSaving"
                                @click="editCampaignName()"
                                :hasLeadingIcon="true"
                              >
                                <template #leading-icon
                                  ><b-icon-pencil></b-icon-pencil
                                ></template>
                                <template #text>Edit name</template>
                              </TheButton>
                            </div>
                          </template>
                        </div>
                        <div class="sm:tw-flex tw-items-center">
                          <h4
                            class="tw-font-medium tw-text-gray-900 sm:tw-w-64 sm:tw-flex-none sm:tw-pr-6 tw-m-0"
                          >
                            Card amount
                          </h4>
                          <div class="tw-flex tw-items-center tw-gap-2">
                            <p
                              class="tw-text-sm tw-font-bold tw-text-gray-900 tw-text-center tw-m-0"
                            >
                              <b-icon-credit-card
                                class="tw-mr-2"
                              ></b-icon-credit-card
                              >${{ this.giftCardAmount }}.00
                            </p>
                            <TheTooltip
                              :toolTip="true"
                              :tooltipContent="giftCardAmountTooltipContent"
                            >
                              <template #icon>
                                <div
                                  class="tw-w-4 tw-h-4 tw-rounded-full tw-border-solid tw-border tw-border-gray-500 tw-flex tw-items-center tw-justify-center hover:tw-bg-slate-100 tw-me-2 tw-cursor-pointer"
                                >
                                  <b-icon-exclamation
                                    class="tw-text-black tw-z-0"
                                  ></b-icon-exclamation>
                                </div>
                              </template>
                            </TheTooltip>
                          </div>
                        </div>
                        <div class="sm:tw-flex tw-items-start">
                          <h4
                            class="tw-font-medium tw-text-gray-900 sm:tw-w-64 sm:tw-flex-none sm:tw-pr-6 tw-m-0"
                          >
                            Gift card selection
                          </h4>
                          <BlockStack :gap="100">
                            <div class="tw-flex tw-items-center tw-gap-2">
                              <p
                                class="tw-text-sm tw-font-bold tw-text-gray-900 tw-text-center tw-m-0"
                              >
                                {{
                                  this.isCustomGiftCardSelection
                                    ? "Custom selection"
                                    : "Recipients choice"
                                }}
                              </p>
                              <TheTooltip
                                :toolTip="true"
                                :tooltipContent="
                                  giftCardSelectionTooltipContent
                                "
                              >
                                <template #icon>
                                  <div
                                    class="tw-w-4 tw-h-4 tw-rounded-full tw-border-solid tw-border tw-border-gray-500 tw-flex tw-items-center tw-justify-center hover:tw-bg-slate-100 tw-me-2 tw-cursor-pointer"
                                  >
                                    <b-icon-exclamation
                                      class="tw-text-black tw-z-0"
                                    ></b-icon-exclamation>
                                  </div>
                                </template>
                              </TheTooltip>
                            </div>
                            <p class="tw-text-sm tw-m-0 tw-text-gray-900">
                              <!-- icon -->
                              <template
                                v-if="
                                  this?.campaign?.metadata?.collection_query
                                    ?.requestBody?.tabName === 'Full collection'
                                "
                              >
                                <b-icon-trophy class="tw-mr-1"></b-icon-trophy>
                              </template>
                              <template
                                v-if="
                                  this?.campaign?.metadata?.collection_query
                                    ?.requestBody?.tabName === 'Casual Dining'
                                "
                                ><b-icon-suit-heart
                                  class="tw-mr-1"
                                ></b-icon-suit-heart>
                              </template>
                              <template
                                v-if="
                                  this?.campaign?.metadata?.collection_query
                                    ?.requestBody?.tabName === 'Coffee & Cafes'
                                "
                                ><b-icon-cup-hot
                                  class="tw-mr-1"
                                ></b-icon-cup-hot>
                              </template>
                              <template
                                v-if="
                                  this?.campaign?.metadata?.collection_query
                                    ?.requestBody?.tabName === 'Fine Dining'
                                "
                                ><b-icon-gem class="tw-mr-1"></b-icon-gem>
                              </template>
                              <template
                                v-if="
                                  this?.campaign?.metadata?.collection_query
                                    ?.requestBody?.tabName ===
                                  'Ice Cream & Desserts'
                                "
                                ><b-icon-cake class="tw-mr-1"></b-icon-cake>
                              </template>
                              <template
                                v-if="
                                  campaign?.metadata?.collection_query
                                    ?.requestBody?.tabName === 'Wine & Spirits'
                                "
                              >
                                <b-icon-brightness-high
                                  class="tw-mr-1"
                                ></b-icon-brightness-high>
                              </template>
                              <!-- text -->
                              <template
                                v-if="
                                  this?.campaign?.metadata?.collection_query
                                    ?.requestBody?.tabName === 'Full collection'
                                "
                              >
                                Full collection</template
                              >
                              <template
                                v-if="
                                  this?.campaign?.metadata?.collection_query
                                    ?.requestBody?.tabName === 'Casual Dining'
                                "
                                >Casual Dining</template
                              >
                              <template
                                v-if="
                                  this?.campaign?.metadata?.collection_query
                                    ?.requestBody?.tabName === 'Coffee & Cafes'
                                "
                                >Coffee & Cafes
                              </template>
                              <template
                                v-if="
                                  this?.campaign?.metadata?.collection_query
                                    ?.requestBody?.tabName === 'Fine Dining'
                                "
                                >Fine Dining
                              </template>
                              <template
                                v-if="
                                  this?.campaign?.metadata?.collection_query
                                    ?.requestBody?.tabName ===
                                  'Ice Cream & Desserts'
                                "
                                >Ice Cream & Desserts
                              </template>
                              <template
                                v-if="
                                  this?.campaign?.metadata?.collection_query
                                    ?.requestBody?.tabName === 'Wine & Spirits'
                                "
                              >
                                Wine & Spirits
                              </template>
                            </p>
                            <p
                              class="tw-pointer-events-none tw-text-sm tw-m-0 tw-text-gray-900"
                            >
                              ${{ campaign.metadata.gift_card_amount }}
                              gift card
                            </p>
                            <p
                              class="tw-pointer-events-none tw-block tw-truncate tw-text-sm tw-m-0 tw-text-gray-900"
                            >
                              <b-icon-geo-alt class="tw-mr-2"></b-icon-geo-alt>
                              <template v-if="neighborhoodList">{{
                                neighborhoodList
                              }}</template>
                              <template v-else>St. Louis, MO</template>
                            </p>
                          </BlockStack>
                        </div>
                      </template>
                    </BlockStack>
                  </BlockStack>
                </template>
              </BlockStack>
            </TheBox>
            <!-- </CardBody> -->
          </TheCard>
        </div>
      </PageSection>
    </ThePage>
  </template>

  <div class="">
    <PageHeader
      :showActions="true"
      class="tw-fixed tw-bottom-0 tw-inset-x-auto tw-right-0"
    >
      <template #subheading-content>
        <template v-if="nameEditIsActive">
          <div class="tw-flex tw-gap-2 tw-items-center">
            <input
              v-model="newCampaignTemplateName"
              type="text"
              id="campaignName"
              placeholder="Template name"
              class="tw-block tw-min-w-72 tw-w-full tw-rounded-md tw-border-0 tw-px-2.5 tw-py-1.5 tw-text-gray-900 tw-ring-1 tw-ring-inset tw-ring-gray-300 placeholder:tw-text-slate-900 focus:tw-ring-2 focus:tw-ring-inset focus:tw-ring-blue-600 tw-text-sm tw-leading-6"
            />
            <div class="tw-flex tw-gap-2 tw-items-center">
              <TheButton
                size="small"
                variant="success"
                :disabled="campaignIsSaving"
                @click="updateCampaign()"
              >
                <template #text>Save</template>
              </TheButton>
              <TheButton
                size="small"
                variant="tertiary"
                :disabled="campaignIsSaving"
                @click="cancelEditingCampaignName()"
              >
                <template #text>Cancel</template>
              </TheButton>
            </div>
          </div>
        </template>
        <template v-if="!nameEditIsActive">
          <div class="tw-flex tw-items-center tw-gap-2 tw-flex-wrap">
            <h2 class="tw-text-lg tw-text-blue-900 tw-m-0">
              {{ campaignName }}
            </h2>
            <TheButton
              size="small"
              variant="tertiary"
              :disabled="campaignIsSaving"
              @click="editCampaignName()"
              :hasLeadingIcon="true"
            >
              <template #leading-icon><b-icon-pencil></b-icon-pencil></template>
              <template #text>Edit name</template>
            </TheButton>
          </div>
        </template>
      </template>

      <template #page-header-actions>
        <template
          v-if="allStepsComplete && campaignIsComplete && currentStep !== 3"
        >
          <div class="tw-flex tw-gap-2">
            <template v-if="!campaignIsSaving || !campaignsAreLoading">
              <TheButton
                :disabled="campaignIsSaving || campaignsAreLoading"
                :hasLeadingIcon="campaignIsSaving || campaignsAreLoading"
                variant="tertiary"
                @click="saveAndExit()"
                size="large"
              >
                <template #leading-icon>
                  <template v-if="campaignIsSaving || campaignsAreLoading">
                    <div role="status">
                      <svg
                        aria-hidden="true"
                        class="tw-inline tw-w-4 tw-h-4 tw-text-gray-200 tw-animate-spin dark:tw-text-gray-600 tw-fill-blue-600"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                      <span class="tw-sr-only">Saving...</span>
                    </div>
                  </template>
                  <template v-else><b-icon-plus-lg></b-icon-plus-lg></template>
                </template>
                <template #text>
                  <template v-if="campaignIsSaving || campaignsAreLoading"
                    >Saving</template
                  >
                  <template v-else>Finish later</template>
                </template>
              </TheButton>
            </template>
            <TheButton :disabled="campaignIsSaving || campaignsAreLoading" variant="new" @click="handleStepChange(3)" size="large">
              <template #text> Review and finalize</template>
            </TheButton>
          </div>
        </template>
        <template
          v-if="allStepsComplete && campaignIsComplete && currentStep === 3"
        >
          <div class="tw-flex tw-gap-2">
            <template v-if="!campaignIsSaving || !campaignsAreLoading">
              <TheButton
                :disabled="campaignIsSaving || campaignsAreLoading"
                :hasLeadingIcon="campaignIsSaving || campaignsAreLoading"
                variant="tertiary"
                @click="saveAndExit()"
                size="large"
              >
                <template #leading-icon>
                  <template v-if="campaignIsSaving || campaignsAreLoading">
                    <div role="status">
                      <svg
                        aria-hidden="true"
                        class="tw-inline tw-w-4 tw-h-4 tw-text-gray-200 tw-animate-spin dark:tw-text-gray-600 tw-fill-blue-600"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                      <span class="tw-sr-only">Saving...</span>
                    </div>
                  </template>
                  <template v-else><b-icon-plus-lg></b-icon-plus-lg></template>
                </template>
                <template #text>
                  <template v-if="campaignIsSaving || campaignsAreLoading"
                    >Saving</template
                  >
                  <template v-else>Finish later</template>
                </template>
              </TheButton>
            </template>

            <TheButton
              :disabled="campaignIsSaving"
              :class="{
                'tw-animate-pulse': this.currentStep,
              }"
              :hasTrailingIcon="!campaignIsSaving && !campaignsAreLoading"
              :hasLeadingIcon="campaignIsSaving || campaignsAreLoading"
              variant="success"
              @click="handleFinalizingTemplate()"
              size="large"
            >
              <template v-if="campaignIsSaving || campaignsAreLoading">
                <div role="status">
                  <svg
                    aria-hidden="true"
                    class="tw-inline tw-w-4 tw-h-4 tw-text-gray-200 tw-animate-spin dark:tw-text-gray-600 tw-fill-blue-600"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                    />
                  </svg>
                  <span class="tw-sr-only">Sending...</span>
                </div>
              </template>
              <template #text>
                <template v-if="campaignIsSaving || campaignsAreLoading"
                  >Finalizing campaign</template
                >
                <template v-else>Finalize template</template>
              </template>

              <template #trailing-icon>
                <template v-if="currentStep !== 2">
                  <b-icon-arrow-right></b-icon-arrow-right>
                </template>
              </template>
            </TheButton>
          </div>
        </template>
        <template v-if="!allStepsComplete || !campaignIsComplete">
          <div class="tw-flex tw-gap-2">
            <template v-if="!campaignIsSaving || !campaignsAreLoading">
              <TheButton
                :disabled="campaignIsSaving || campaignsAreLoading"
                :hasLeadingIcon="campaignIsSaving || campaignsAreLoading"
                variant="tertiary"
                @click="saveAndExit()"
                size="large"
              >
                <template #leading-icon>
                  <template v-if="campaignIsSaving || campaignsAreLoading">
                    <div role="status">
                      <svg
                        aria-hidden="true"
                        class="tw-inline tw-w-4 tw-h-4 tw-text-gray-200 tw-animate-spin dark:tw-text-gray-600 tw-fill-blue-600"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                      <span class="tw-sr-only">Saving...</span>
                    </div>
                  </template>
                  <template v-else><b-icon-plus-lg></b-icon-plus-lg></template>
                </template>
                <template #text>
                  <template v-if="campaignIsSaving || campaignsAreLoading"
                    >Saving</template
                  >
                  <template v-else>Finish later</template>
                </template>
              </TheButton>
            </template>
            <TheButton
              :disabled="
                (currentStep === 2 && !allStepsComplete) ||
                campaignIsSaving ||
                campaignsAreLoading
              "
              :hasTrailingIcon="!campaignIsSaving && !campaignsAreLoading"
              :hasLeadingIcon="campaignIsSaving || campaignsAreLoading"
              variant="secondary"
              @click="goToNextStep()"
              size="large"
            >
              <template #leading-icon>
                <template v-if="campaignIsSaving || campaignsAreLoading">
                  <div role="status">
                    <svg
                      aria-hidden="true"
                      class="tw-inline tw-w-4 tw-h-4 tw-text-gray-200 tw-animate-spin dark:tw-text-gray-600 tw-fill-blue-600"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"
                      />
                    </svg>
                    <span class="tw-sr-only">Saving...</span>
                  </div>
                </template>
                <template v-else><b-icon-plus-lg></b-icon-plus-lg></template>
              </template>
              <template #text>
                <template v-if="campaignIsSaving || campaignsAreLoading"
                  >Saving</template
                >
                <template v-else>Save and continue</template>
              </template>
              <template #trailing-icon>
                <template v-if="currentStep !== 2">
                  <b-icon-arrow-right></b-icon-arrow-right>
                </template>
              </template>
            </TheButton>
          </div>
        </template>
      </template>
    </PageHeader>
  </div>
</template>

<script>
import CampaignRecipientsSelection from "../../components-v2/campaigns/CampaignRecipientsSelection";
import ThePage from "../../components-v2/ui/layout/ThePage.vue";
import PageHeader from "../../components-v2/ui/layout/PageHeader.vue";
import TheCard from "../../components-v2/ui/layout/TheCard.vue";
import CardHeader from "../../components-v2/ui/layout/CardHeader.vue";
import CardBody from "../../components-v2/ui/layout/CardBody.vue";
import TheBox from "../../components-v2/ui/layout/TheBox.vue";
import BlockStack from "../../components-v2/ui/layout/BlockStack.vue";
import TheButton from "@/components-v2/ui/actions/TheButton.vue";
import TheLink from "@/components-v2/ui/actions/TheLink.vue";
import TheModal from "../../components-v2/ui/modals/TheModal.vue";
import ModalBody from "../../components-v2/ui/layout/ModalBody.vue";
import SuccessContent from "../../components-v2/ui/modals/SuccessContent.vue";
import RecipientsIndexTableV2 from "../../components-v2/recipients/RecipientsIndexTableV2";
import GiftCardsGridV2 from "../../components-v2/gift-cards/GiftCardsGridV2.vue";
import PageSection from "../../components-v2/ui/layout/PageSection.vue";
import ListSkeleton from "../../components-v2/ui/skeletons/ListSkeleton.vue";
import PulseAnimation from "../../components-v2/ui/feedback/PulseAnimation.vue";
import NotificationMessage from "../../components-v2/ui/feedback/NotificationMessage.vue";
import TheTooltip from "../../components-v2/ui/forms/TheTooltip.vue";

import { listMailCampaignById } from "@/services/campaignService";
import {
  upsertMailCampaign,
  sendMailCampaign,
} from "@/services/campaignService";

export default {
  name: "CampaignTemplateBuilder",
  components: {
    TheTooltip,
    CampaignRecipientsSelection,
    TheBox,
    BlockStack,
    GiftCardsGridV2,
    ThePage,
    PageHeader,
    TheLink,
    RecipientsIndexTableV2,
    TheCard,
    CardHeader,
    CardBody,
    TheButton,
    TheModal,
    ModalBody,
    SuccessContent,
    PageSection,
    ListSkeleton,
    PulseAnimation,
    NotificationMessage,
  },
  async created() {
    await this.loadCampaignDetails();
    this.loadSteps();
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit(
      "campaigns/RESET_CAMPAIGN_GIFTS_SELECTION_REQUEST_BODY",
      null
    );
    next();
  },
  watch: {
    currentStep: {
      handler: "loadSteps",
      deep: true,
    },
  },
  data() {
    return {
      campaign: {},
      steps: [
        { id: 1, name: "Set gift card amount", status: 0 },
        { id: 2, name: "Select gift cards", status: 0 },
        { id: 3, name: "Review details", status: 0 },
      ],
      newCampaignTemplateName: "",
      currentStep: 1,
      showSuccessModal: true,
      giftCardAmountIsValid: false,
      customGiftCardValueSelected: false,
      isToggled: false,
      campaignsAreLoading: true,
      campaignIsSaving: false,
      campaignIsComplete: false,
      showGlobalError: false,
      showCampaignRecipients: false,
      nameEditIsActive: false,
    };
  },
  computed: {
    // user
    user() {
      return this?.$store?.state?.auth?.user;
    },
    // Steps
    getSteps() {
      return this.steps;
    },
    // Campaign from details
    campaignFromEmail() {
      return this?.campaign?.from?.email;
    },
    campaignFromName() {
      return this?.campaign?.from?.name;
    },
    giftCardSelectionTooltipContent() {
      return this.isCustomGiftCardSelection
        ? "Recipients first see your curated list of e-gift cards, but they can always explore and choose any card from the Bold collection."
        : "Recipients get to explore and pick any e-gift card from the Bold collection.";
    },
    giftCardAmountTooltipContent() {
      return "The cash value of the e-gift card that recipients can redeem.";
    },
    // Campaign name
    campaignName() {
      return this?.campaign?.metadata?.campaign_template?.name
        ? this?.campaign?.metadata?.campaign_template?.name
        : "Untitled Template";
    },
    // Gift card amount
    giftCardAmount() {
      return parseInt(this?.campaign?.metadata?.gift_card_amount) || 0;
    },
    // gift card selection
    isCustomGiftCardSelection() {
      return this?.campaign?.metadata?.collection_query?.custom_selection_ids &&
        this?.campaign?.metadata?.collection_query?.custom_selection_ids
          .length > 0
        ? true
        : false;
    },
    // Vendor ids of custom gift card selection
    customSelection() {
      return this?.campaign?.metadata?.collection_query
        ?.custom_selection_ids === 0 ||
        this?.campaign?.metadata?.collection_query?.custom_selection_ids
          .length === 0
        ? 0
        : this?.campaign?.metadata?.collection_query?.custom_selection_ids;
    },
    // check if all campaign requirement are complete
    allStepsComplete() {
      return this.giftCardAmount > 0 && this.customSelection;
    },

    /** error notifications */
    notificationTypes() {
      return this.$store.getters["alerts/getAlertTypes"];
    },
    neighborhoodList() {
      // Check if campaign object has collection_query property
      if (
        this?.campaign?.metadata?.collection_query?.requestBody?.filter?.$and
      ) {
        // Get all 'and' conditions
        const andConditions =
          this?.campaign?.metadata?.collection_query?.requestBody?.filter?.$and;

        // Check if 'and' conditions exist
        if (andConditions && Array.isArray(andConditions)) {
          // Loop through each condition in '$and'
          for (let condition of andConditions) {
            // Check if the condition includes 'metadata.neighborhoods'
            if (condition["metadata.neighborhoods"]) {
              // Return the value of 'metadata.neighborhoods'
              return condition["metadata.neighborhoods"].$in.join(", ");
            }
          }
        }
      }
      // Return 'Not specified' if 'metadata.neighborhoods' is not found
      return false;
    },
    getCampaignSelectionRequestBody() {
      return this.$store.getters["campaigns/getCampaignSelectionRequestBody"];
    },
  },
  methods: {
    /** handle loading campaign by id */
    async loadCampaignDetails() {
      this.campaignsAreLoading = true;
      const campaignId = this.$route.params.campaignId;

      try {
        const response = await listMailCampaignById(campaignId);
        const campaign = response.data.result.records[0];
        this.campaign = campaign;
        const requestBody = campaign.metadata.collection_query.requestBody;

        this.$store.commit(
          "campaigns/SET_CAMPAIGN_GIFTS_SELECTION_REQUEST_BODY",
          requestBody
        );
      } catch (error) {
        this.handleErrorFromAPI(
          error,
          "We couldn't load your campaign. Please reload the page and try again."
        );
      } finally {
        this.campaignsAreLoading = false;
      }
    },

    /** handle finalizing campaign template */
    async handleFinalizingTemplate() {
      const isFinalizing = true;
      this.updateCampaign(isFinalizing);
    },

    /** handle upserting a campaign by id */
    async updateCampaign(updateStatus) {
      /**
       * @type {import('@boldxchange/sdk/defs').Client}
       */
      const api = await this.getBoldClient();

      this.campaignIsSaving = true;
      const campaignPatch = this.getCampaignUpdatePatch(updateStatus);
      const campaignId = this.campaign._id;

      try {
        await api.upsertMailCampaign(null, {
          filter: { _id: campaignId },
          patch: campaignPatch,
        });

        const requestBody = this.campaign.metadata.collection_query.requestBody;

        this.$store.commit(
          "campaigns/SET_CAMPAIGN_GIFTS_SELECTION_REQUEST_BODY",
          requestBody
        );

        this.handleSuccess(updateStatus);
        return true;
      } catch (error) {
        console.log(error);
        this.handleErrorFromAPI(
          error,
          "Something went wrong while attempting to save your campaign. Please try again."
        );
      } finally {
        this.campaignIsSaving = false;
      }
    },
    getCampaignUpdatePatch(updateStatus) {
      const userId = this?.user?.id;
      const fromEmail = this.campaignFromEmail;
      const fromName = this.campaignFromName;
      const html = this.campaign.html;
      const recipients = this.campaign.recipients;
      const { subject, text } = this.campaign;

      const status = updateStatus !== undefined ? "saved" : "draft";
      const campaignName =
        this.newCampaignTemplateName.trim() !== ""
          ? this.newCampaignTemplateName
          : this.campaignName;

       // Initialize the campaign update patch object
      const campaignUpdatePatch = {
        from: { email: fromEmail, name: fromName },
        recipients,
        subject,
        text,
        html,
        "metadata.campaign_template.name": campaignName,
        "metadata.campaign_template.status": status,
        "metadata.campaign_template.isPrivate":
          this.campaign.metadata.campaign_template.isPrivate,
        "metadata.campaign_name": "Untitled Campaign",
        "metadata.campaign_status": "draft",
        "metadata.campaign_type": "link",
        "metadata.gift_card_amount": this.giftCardAmount,
        "metadata.collection_query.custom_selection_ids": this.customSelection,
        "metadata.collection_query.gift_card_amount": this.giftCardAmount,
        "metadata.collection_query.requestBody":
          this.getCampaignSelectionRequestBody,
        user: userId,
      };

      return campaignUpdatePatch;
    },

    /** handle custom gift card selection */
    updateCampaignCustomSelection(selectedCards) {
      this.campaign.metadata.collection_query.custom_selection_ids =
        selectedCards;
      this.loadSteps();
    },

    /** handle gift card amount selection */
    validateCustomGiftCardValue() {
      const trimmedValue = this.campaign.metadata.gift_card_amount.trim();
      const value = parseFloat(trimmedValue);

      // Check if the trimmed value is a valid number and meets the criteria
      if (!Number.isNaN(value) && value >= 5 && Number.isSafeInteger(value)) {
        this.giftCardAmountIsValid = true;
        this.campaign.metadata.gift_card_amount = Math.round(value).toString(); // Convert back to string
        this.loadSteps();
        this.clearTimeoutIfNeeded();
      } else {
        this.clearTimeoutIfNeeded();

        // Reset to "0" string only if the input is not a valid number
        this.timeoutId = setTimeout(() => {
          this.campaign.metadata.gift_card_amount = "0"; // Reset to "0" string
          this.giftCardAmountIsValid = false;
          this.loadSteps();
        }, 350);
      }
    },
    clearTimeoutIfNeeded() {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
    },
    setGiftCardAmount(value) {
      if (!this.customGiftCardValueSelected) {
        this.campaign.metadata.gift_card_amount = value.toString(); // Convert to string
      }
      this.loadSteps();
    },

    /** handle steps */
    async handleStepChange(step) {
      const successfulRes = await this.updateCampaign();
      if (successfulRes) {
        this.currentStep = step;
        this.loadSteps();
      }
    },
    async goToNextStep() {
      const successfulRes = await this.updateCampaign();
      if (successfulRes) {
        this.currentStep++;
        this.loadSteps();
      }
    },
    async saveAndExit() {
      const successfulRes = await this.updateCampaign();
      if (successfulRes) {
        this.$router.push("/templates");
      }
    },
    loadSteps() {
      const updatedSteps = this.updateSteps(this.campaign, this.steps);
      this.steps = updatedSteps;
    },
    updateSteps(campaign, steps) {
      const giftCardAmountComplete = this.giftCardAmount ? true : false;
      const giftCardSelectionComplete = this.customSelection;

      // Update Step 1
      this.updateStepStatus(steps, 1, giftCardAmountComplete ? 1 : 0);

      // Update Step 2
      this.updateStepStatus(steps, 2, giftCardSelectionComplete ? 1 : 0);

      // Update Step 3
      const allStepsComplete =
        giftCardAmountComplete && giftCardSelectionComplete;
      this.updateStepStatus(steps, 3, allStepsComplete ? 1 : 0);

      this.campaignIsComplete = allStepsComplete;

      return steps;
    },
    updateStepStatus(steps, stepId, status) {
      const stepIndex = steps.findIndex((step) => step.id === stepId);
      if (stepIndex !== -1) {
        steps[stepIndex].status = status;
      }
    },

    /** handle campaign type selection */
    setCampaignType(type) {
      this.campaign.metadata.campaign_type = type;
      this.loadSteps();
    },
    conditionallySetCampaignTypeToEmail() {
      if (this.campaignRecipients.length <= 1) {
        this.setCampaignType("email");
      }
    },

    /** handle gift card selection toggle */
    handleCalendarSelection(calendar) {
      // Check if we are toggling off the currently selected calendar
      if (this.calendarState[calendar]) {
        // If yes, deselect everything
        this.campaign.booking = {
          provider: calendar,
          summary: "",
          description: "",
          enabled: false,
          required: false,
        };
        Object.keys(this.calendarState).forEach((key) => {
          this.calendarState[key] = false;
        });
      } else {
        // If no, select the new calendar and update the booking information
        Object.keys(this.calendarState).forEach((key) => {
          this.calendarState[key] = key === calendar;
        });
        this.campaign.booking = {
          provider: calendar,
          summary: "",
          description: "",
          enabled: true,
          required: true,
        };
      }
      this.loadSteps();
    },

    /** handle link copy */
    async copyLink() {
      const linkToCopy = this.campaignGiftUrl;
      await navigator.clipboard.writeText(linkToCopy);
      this.linkCopied = true;
    },

    /** handle editing campaign name */
    editCampaignName() {
      this.nameEditIsActive = !this.nameEditIsActive;
    },
    cancelEditingCampaignName() {
      this.nameEditIsActive = !this.nameEditIsActive;
      this.newCampaignTemplateName = "";
    },

    /** success and error handling */
    handleSuccess(updateStatus) {
      if (updateStatus) {
        this.$router.push("/templates");
      } else {
        this.$store.dispatch("alerts/showAlert", {
          type: this.notificationTypes.SUCCESS,
          message: "Your campaign was saved.",
          duration: 2000,
          id: Date.now(),
        });
        this.nameEditIsActive = false;
        this.loadCampaignDetails();
        this.campaignIsSaving = false;
      }
    },
    handleErrorFromAPI(error, customMessage = null) {
      let errorMessage = "Something went wrong. Please try again."; // Default message

      // If a custom message is provided, prioritize it
      if (customMessage) {
        errorMessage = customMessage;
      } else if (error?.response) {
        // Process API error message if customMessage is not provided
        if (
          error?.response?.data &&
          error?.response?.data?.error &&
          error?.response?.data?.error?.source?.errors
        ) {
          const sourceErrors = error.response.data.error.source.errors;
          const firstErrorKey = Object.keys(sourceErrors)[0];
          errorMessage = sourceErrors[firstErrorKey].message;
        } else {
          errorMessage =
            error.response.data.message || "An unknown error occurred.";
        }
      } else if (error?.request) {
        errorMessage =
          "No response was received from the server. Please check your internet connection.";
      } else {
        errorMessage = "An error occurred with your request. Please try again.";
      }

      //Dispatch the error message as before
      this.$store.dispatch("alerts/showAlert", {
        type: this.notificationTypes.ERROR,
        message: errorMessage,
        duration: 6000,
        id: Date.now(),
      });
      this.campaignIsSaving = false;
      this.campaignsAreLoading = false;
      console.error(errorMessage); // Keep for debugging purposes
    },
  },
};
</script>

<style scoped></style>
